import { IPublishOfferErrors } from '../../../../../services/publishOffer';

export const checkSubagentNotEnoughMoneyError = (errors: IPublishOfferErrors | null): boolean => {
  // 11 - код ошибки недостатка средств по лимиту субагента от агентства
  return !!errors?.not_enough_money && errors.not_enough_money.some(({ code }) => Number(code) === 11);
};
